import styled from 'styled-components';

export const TitleWrapper = styled.span`
  font-size: 13px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0%;
  color: ${({ theme }) => theme.colors.black6};
`;

export const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Item = styled.span`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black9};
`;
